import { EndeavourCredits } from '@endeavour/console-credits'
import { ENV } from './environment.bootstrap'

ENV.whenProduction(() => EndeavourCredits({
    projectName: 'Basiclabel.nl',
}))
